import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";

// Layout & Pages
import Layout from './components/Layout';
import Intro from './pages/Intro';
import SyncEyes from './pages/SyncEyes';
import GameStart from './pages/GameStart';
import ReflexTest from './pages/ReflexTest';
import AboutOmoreGames from './pages/AboutOmoreGames';
import MoreGames from './pages/MoreGames';
import FocusGame from './pages/FocusTest';
import LogicGame from './pages/BrainTest';
import ScrollToTop from './components/ScrollToTop';
import ContactOmoreGames from './pages/Contact';
import TermsOmoreGames from './pages/Terms';
import PrivacyOmoreGames from './pages/Privacy';
import AxionIntro from './pages/AxionIntro';
import DualisIntro from './pages/DualisIntro';
import SynchroIntro from './pages/SynchroIntro';
import GamesHub from './pages/GamesHub';
import { Toaster } from 'react-hot-toast';


// 1. Initialize outside or inside a one-time useEffect
const GA_ID = process.env.REACT_APP_GA_ID;

const AnalyticsTracker = () => {
  const location = useLocation();
  const isInitialized = useRef(false);

  useEffect(() => {
    // 2. Initialize only once
    if (GA_ID && !isInitialized.current) {
      ReactGA.initialize(GA_ID);
      isInitialized.current = true;
    }

    // 3. Track Pageview
    if (isInitialized.current) {
      const path = location.pathname + location.search;
      
      ReactGA.send({ 
        hitType: "pageview", 
        page: path,
        title: document.title // Best practice for GA4
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <ScrollToTop />
        <Toaster position="top-center" />
      <Routes>
        {/* The Layout provides the CRT/Terminal frame for all pages */}
        <Route element={<Layout />}>

          {/* Page 1: The Start / Story Intro */}
          <Route path="/" element={<GamesHub />} />
                    <Route path="/neuralis" element={<Intro />} />

          <Route path="/axion" element={<AxionIntro />} />
          <Route path="/dualis" element={<DualisIntro />} />
          <Route path="/synchro" element={<SynchroIntro />} />



          <Route path="/aboutomore" element={<AboutOmoreGames />} />
          <Route path="/gamelibrary" element={<MoreGames />} />
          <Route path="/contact" element={<ContactOmoreGames />} />
          <Route path="/terms" element={<TermsOmoreGames />} />
          <Route path="/privacy" element={<PrivacyOmoreGames />} />





          {/* Page 2-4: The Sensory Sync Missions */}
          <Route path="/sync/eyes" element={<SyncEyes />} />
          <Route path="/game/start" element={<GameStart />} />
          <Route path="/game/reflex" element={<ReflexTest />} />
          <Route path="/game/focus" element={<FocusGame />} />
          <Route path="/game/memory" element={<LogicGame />} />


          {/* Fallback to Start */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default App;